import React, {useEffect, useState} from "react";
import {DropdownButton, Dropdown} from "react-bootstrap";
import './DropdownChip.css';

function DropdownChip({
    hint,
    init,
    items,
    onClick
}) {
    const [selectedIndex, setSelectedIndex] = useState(init);

    const handleClick = (index) => {
        setSelectedIndex(index);
        onClick(index);
    };

    useEffect(() => {
        setSelectedIndex(init);
    }, [init]);

    return (
        <DropdownButton
            className={`body3-txt ${items[selectedIndex]}`}
            title={selectedIndex >= 0 ? items[selectedIndex] : hint}
        >
            {
                items.map((item, index) => (
                    <Dropdown.Item
                        key={index}
                        className="profile-modal-category-txt"
                        onClick={() => handleClick(index)}>
                        {item}
                    </Dropdown.Item>
                ))
            }
        </DropdownButton>
    );
}

export default DropdownChip;